import { ReactNode } from "react";
import { useAuthToken } from "../../../hooks/useAuthToken";
import { UserRole } from "../../../types/User.ts";

const Authorized = ({
  role = UserRole.User,
  placeholderLoading = null,
  ifUnauthorized = null,
  children,
}: {
  role?: UserRole;
  placeholderLoading?: ReactNode;
  ifUnauthorized?: ReactNode;
  children?: ReactNode;
}) => {
  const token = useAuthToken();

  if (token.status === "loading") return placeholderLoading || ifUnauthorized;
  if (token.status === "error") return ifUnauthorized;
  if (token.status === "ok" && token.isRole(role)) return children;
};

export default Authorized;
